export const SUCCESS_PAGE_BOARD_CODE = 'alpr_result_page';
